import React, { createContext, useContext, useState, useEffect } from "react";

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const [scrollDirection, setScrollDirection] = useState(null);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [contentScrollRef, setContentScrollRef] = useState(null);

  const registerScrollContainer = (ref) => {
    if (ref && ref !== contentScrollRef) {
      setContentScrollRef(ref);
    }
  };

  useEffect(() => {
    if (!contentScrollRef) return;

    const handleScroll = () => {
      const currentScrollTop = contentScrollRef.scrollTop;
      setScrollDirection(currentScrollTop < lastScrollTop);
      setLastScrollTop(currentScrollTop);
    };

    contentScrollRef.addEventListener("scroll", handleScroll);
    return () => {
      contentScrollRef.removeEventListener("scroll", handleScroll);
    };
  }, [contentScrollRef, lastScrollTop]);

  return (
    <ScrollContext.Provider
      value={{
        contentScrollRef,
        scrollDirection,
        registerScrollContainer,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
};

// 自定义Hook便于组件使用上下文
export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useScrollContext must be used within a ScrollProvider");
  }
  return context;
};
